/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlMatterLayoutsQueryVariables = Types.Exact<{
  matterTypeIds:
    | Array<Types.Scalars["ID"]["input"]>
    | Types.Scalars["ID"]["input"];
}>;

export type GqlMatterLayoutsQuery = {
  __typename: "Query";
  matterLayouts: Array<{
    __typename: "MatterLayout";
    id: string;
    providerId: string;
    name: string;
    parentId?: string | null;
    parentName?: string | null;
    parentProviderId?: string | null;
    displayName?: string | null;
  }>;
};

export const MatterLayoutsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "matterLayouts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "matterTypeIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "matterLayouts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "matterTypeIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "matterTypeIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "matterLayoutFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "matterLayoutFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MatterLayout" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "providerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "parentName" } },
          { kind: "Field", name: { kind: "Name", value: "parentProviderId" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlMatterLayoutsQuery,
  GqlMatterLayoutsQueryVariables
>;
